import { Link } from "react-router-dom";
import { Phone, MessageCircle, MapPin, Clock } from "lucide-react";
import { BRAND, BRANCHES, telLink, waLink } from "@/lib/brand";
import { TESTIDS } from "@/constants/testIds";

export default function Footer() {
  return (
    <footer
      data-testid={TESTIDS.footer}
      className="bg-[#641C24] text-[#FFFDF8]"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-14">
          <div className="md:col-span-2">
            <div className="font-display text-4xl font-bold tracking-tight">
              Top<span className="text-[#D4AF37]">Rate</span>
            </div>
            <div className="text-xs uppercase tracking-[0.28em] mt-2 text-[#FFFDF8]/70">
              Cash for Gold · Sona Do Paisa Lo
            </div>
            <p className="mt-6 text-sm text-[#FFFDF8]/85 leading-relaxed max-w-md">
              Govt. approved gold valuers offering the best rate for your
              jewellery, silver and gold. Cash or bank transfer in 30 minutes.
              Serving Gurgaon, Delhi NCR and entire North India.
            </p>

            <div className="flex flex-wrap gap-3 mt-8">
              <a
                href={telLink}
                className="inline-flex items-center gap-2 bg-[#D4AF37] text-[#2D181A] hover:bg-[#B8860B] px-5 py-3 text-sm font-semibold uppercase tracking-wider"
              >
                <Phone size={16} /> {BRAND.phone}
              </a>
              <a
                href={waLink()}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1FBA57] px-5 py-3 text-sm font-semibold uppercase tracking-wider"
              >
                <MessageCircle size={16} /> WhatsApp
              </a>
            </div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.28em] text-[#D4AF37]">
              Explore
            </div>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <Link to="/" className="hover:text-[#D4AF37] transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="hover:text-[#D4AF37] transition-colors"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="hover:text-[#D4AF37] transition-colors"
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/branches"
                  className="hover:text-[#D4AF37] transition-colors"
                >
                  Branches
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="hover:text-[#D4AF37] transition-colors"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.28em] text-[#D4AF37]">
              Branches
            </div>
            <ul className="mt-5 space-y-5 text-sm text-[#FFFDF8]/85">
              {BRANCHES.map((b) => (
                <li key={b.id}>
                  <div className="flex items-start gap-2">
                    <MapPin
                      size={14}
                      className="mt-1 shrink-0 text-[#D4AF37]"
                    />
                    <div>
                      <div className="font-semibold text-[#FFFDF8]">
                        {b.name}
                      </div>
                      <div className="text-[#FFFDF8]/75 leading-relaxed">
                        {b.address}
                      </div>
                      <div className="flex items-center gap-1 text-xs mt-1 text-[#FFFDF8]/60">
                        <Clock size={12} /> {b.hours}
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-[#FFFDF8]/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-[#FFFDF8]/60">
          <div>
            © {new Date().getFullYear()} Top Rate. All rights reserved. Govt.
            approved valuers.
          </div>
          <div className="uppercase tracking-[0.24em]">
            Serving all of North India
          </div>
        </div>
      </div>
    </footer>
  );
}
